<template>
  <div class="nk-block">
    <div class="card min-heightvh">
      <slot />
    </div>
  </div>
</template>
